var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityPhysicalTherapy = function SvgFacilityPhysicalTherapy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-160v-160q0-83 58.5-141.5T320-520h429q38 0 64.5 26t26.5 64q0 31-19 55.5T773-342l-93 27v184q0 15.909-7.057 28.788T654-81q-12.148 8.25-26.574 10.125T598-75l-216-85zm500-140H375q-14 0-23 9t-11 20 3.682 22.455T364-232l256 101zm-440 80h113q-6-10-9.5-21.5T280-265q0-39 28-67t67-28h238l145-40q14-4 19-13t3-20-10-19-21-8H320q-58.333 0-99.167 40.833Q180-378.333 180-320zm220-340q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47m0-60q42 0 71-29t29-71-29-71-71-29-71 29-29 71 29 71 71 29m0-100"
  })));
};
export default SvgFacilityPhysicalTherapy;